<template>
    <div>
        <el-button type="primary"
                   @click="startTour"
                   :disabled="!tourAvailable">
            {{$t('addTranslationTour.tourName')}}
        </el-button>

        <el-tour v-model="tourStart"
                 :target-area-clickable="false">

            <el-tour-step :target="sourceTextTarget"
                          :title="$t('addTranslationTour.sourceText')"
                          :description="$t('addTranslationTour.sourceTextDescription')" />

            <el-tour-step :target="targetTextTarget"
                          :title="$t('addTranslationTour.targetText')"
                          :description="$t('addTranslationTour.targetTextDescription')" />

            <el-tour-step :target="saveTranslationTarget"
                          :title="$t('addTranslationTour.saveTranslation')"
                          :description="saveTranslationDescription" />

            <el-tour-step :target="limitsTarget"
                          :title="$t('addTranslationTour.limits')">
                {{$t('addTranslationTour.limitsDescription')}}

                <div class="icon-wrapper">
                    <SegmentStatusIcon />
                </div>

            </el-tour-step>
        </el-tour>
    </div>
</template>

<script lang="js">
    import { defineComponent } from 'vue';

    import { shortcuts } from '@/utils/shortcuts';
    import SegmentStatusIcon from '@/components/SegmentStatusIcon.vue';

    export default defineComponent({
        props: {
            tourAvailable: {
                type: Boolean,
                default: false,
            }
        },
        components: {
            SegmentStatusIcon,
        },
        data() {
            return {
                tourStart: false,

                sourceTextTarget: "#source-container",
                targetTextTarget: "#tareget-container",
                saveTranslationTarget: "#save-button",
                saveTranslationDescription: this.$t("addTranslationTour.saveTranslationDescription", [shortcuts.addTranslation.win, shortcuts.saveMoveNext.win]),
                limitsTarget: "#segment-container",
            };
        },
        methods: {
            startTour() {
                const result = document.getElementById("shortcut-button");
                if (result != null) {
                    result.click();
                }
                this.tourStart = true;
            },
        }
    })
</script>

<style scoped>

    .icon-wrapper {
        margin-top: 20px;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
    }

</style>